import { ActionButtonVariantType, ActionButtons } from './ActionButton'

/**
 * This function extends the action buttons object (ActionButtons type).
 *
 * @param {Partial<ActionButtons<ActionButtonVariantType>>} buttons - An object of action buttons.
 * @returns {Object} - An object with computed properties:
 *  - getNonHidden: an array of action buttons that are not hidden.
 *  - shouldHideActionBar: checks if all action buttons are disabled or hidden.
 *  - isConsecutiveDivider: checks if the current button and the previous one are both dividers.
 *  - isLastDivider: checks if the last button to render is a divider.
 */
export const actionButtonsHelper = (
    buttons: Partial<ActionButtons<ActionButtonVariantType>>
) => {
    const getNonHidden = Object.values(buttons).filter(
        (btn) => btn?.isHidden !== true
    )
    // check when all action buttons are disabled or hidden
    const shouldHideActionBar = getNonHidden
        .filter((btn) => btn?.variant !== 'Divider')
        .every((btn) => btn?.disabled === true)

    const currentIsDivider = (idx: number) =>
        getNonHidden[idx]?.variant === 'Divider'

    const isConsecutiveDivider = (idx: number) =>
        currentIsDivider(idx) &&
        // next is a divider?
        currentIsDivider(idx + 1)

    const isLastDivider = (idx: number) =>
        currentIsDivider(idx) && getNonHidden.length === idx + 1

    return {
        getNonHidden,
        shouldHideActionBar,
        isConsecutiveDivider,
        isLastDivider,
    }
}
